import type { SidebarPreferences } from '@shared/lib/navigation';
import { apiClient } from './api-client';

/** `version` is the server's compare-and-set counter; 0 means nothing is saved yet. */
export type VersionedSidebarPreferences = SidebarPreferences & { version: number };

export const sidebarPreferencesApi = {
  get: (role: string) =>
    apiClient.get<VersionedSidebarPreferences>(`/users/sidebar-preferences/${role}`),
  save: (role: string, preferences: VersionedSidebarPreferences) =>
    apiClient.put<VersionedSidebarPreferences>(`/users/sidebar-preferences/${role}`, preferences),
};
